<template>
    <div id="add-item-to-basket-overlay">
        <div class="modal fade">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="basketItem">

                    <!-- MODAL HEADER -->
                    <div class="modal-header">
                        <div class="modal-title h5">{{ $translate("Ceres::Template.singleItemAdded") }}</div>
                        <span class="text-muted ml-auto"><span class="timer"></span>s</span>
                        <button type="button" class="closeOverlay" data-dismiss="modal" :aria-label="$translate('Ceres::Template.closeIcon')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <!-- ./MODAL HEADER -->

                    <!-- MODAL BODY -->
                    <div class="modal-body">
                      <!-- -->
                      <div v-if="manyMoreItems.items.length > 0">
                        <div class="text-center mb-4 font-weight-bold mt-3">
                          {{ $translate("Snaply5::Template.overlayBasketItemsText",{"count": manyMoreItems.count }) }}
                        </div>
                        <div style="display: flex;justify-content: center;">
                          <div class="choosen-colors">
                            <div v-for="item in manyMoreItems.items">
                              <div>
                                <img :src="item.data.images.all[0].urlPreview" class="img-fluid">
                              </div>
                            </div>
                            <template v-if="manyMoreItems.count > 4">
                              <div class="lot-more-colors">
                                <span class="dot"></span>
                                <span class="dot"></span>
                                <span class="dot"></span>
                              </div>
                            </template>
                          </div>
                        </div>
                      </div>

                      <template v-else>
                        <div class="row is-table-row">
                          <div class="col-4" style="min-height: 80px;">
                            <img style="max-height: 140px;" class="img-fluid mx-auto" :src="current.image.urlPreview" :alt="current.image.names.alternate" :title="current.image.names.alternate"/>
                          </div>
                          <div class="col-8">
                            <p>
                              <strong>{{ current.variation.data.texts.name1 }}</strong>
                              <br>
                              <span v-if="countAdditionalBasketItems > 0">{{ $translate("Ceres::Template.basketItemOverlayAdditionalCount", {"count": countAdditionalBasketItems }) }}</span>
                            </p>

                            <p class="small">
                              <strong>
                                <span class="text-muted">{{ current.quantity }} x </span>
                                <span>{{ current.price | currency }}</span>
                              </strong>
                            </p>

                            <p class="small" v-for="attribute in current.variation.data.attributes">
                              <strong>{{ attribute.attribute.names.name }}</strong>:
                              <span>{{ attribute.value.names.name }}</span>
                            </p>

                          </div>
                        </div>
                      </template>
                      <!-- -->
                      <div class="row">
                        <div class="col-12">
                          <a v-waiting-animation-infinite :href="urls.basket" rel="nofollow" class="btn btn-primary mr-2 pull-right" style="min-width:33%;">
                            <i class="fa fa-shopping-cart" aria-hidden="true"></i>
                            {{ $translate("Snaply5::Template.singleItemBasketOverlay") }}
                          </a>
                        </div>

                        <template v-if="crossitems.length > 0 && current.quantity > 0.1">
                          <div class="col-12">
                            <div class="h3 my-4">
                              {{ $translate("Snaply5::Template.basketOverlayHeadlineCrossSeller") }}
                            </div>
                          </div>
                        </template>
                      </div>
                      <template v-if="crossitems.length > 0 && current.quantity > 0.1 ">
                        <carousel :items-per-page="3" v-show="crossitems.length > 0" :mini="this.crossitems.length < 3">
                          <template slot="items" v-for="item in crossitems">
                            <category-item
                                :key="item.id"
                                :item-data="item.data"
                                :decimal-count="$ceres.config.item.storeSpecial"
                                :disable-carousel-on-mobile="false"
                                :show-rating="true"
                                :show-cart="true"
                                :wish-is-active="false"
                                :show-variation-image-possible="true"
                                :show-attributes="true">
                            </category-item>
                          </template>
                        </carousel>
                      </template>
                    </div>
                    <!-- ./MODAL BODY -->

                    <!-- MODAL FOOTER -->
                    <slot name="extendOverlayButtons"></slot>
                    <!-- ./MODAL FOOTER -->

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { isNullOrUndefined } from "../helper/utils";
import { mapState } from "vuex";
import OrderPropertyValueList from "../components/item/OrderPropertyValueList.vue"

const ModalService  = require("../services/ModalService");
const ApiService    = require("../services/ApiService");

export default {
    name: "add-item-to-basket-overlay",
    inject:
      {
        itemId:
            {
              default: null
            }
      },
    components: {
        OrderPropertyValueList
    },

    props: {
        defaultTimeToClose: {
            type: Number,
            default: 15
        }
    },

    data()
    {
        return {
            price: 0,
            basketItem: null,
            firstBasketItem:null,
            countAdditionalBasketItems: 0,
            firstTime:false,
        };
    },

    mounted()
    {
        if (App.config.basket.addItemToBasketConfirm === "overlay")
        {
            ApiService.listen("AfterBasketItemUpdate", data =>
            {
                const updatedBasketItem = data.basketItems[0];

                if (!this.isBasketItemQuantityUpdate)
                {

                  const basketItem = this.basketItems.find(item => item.id === updatedBasketItem.id) || {};

                    this.showItem(basketItem);
                }
            });

            ApiService.listen("AfterBasketItemAdd", data =>
            {
                this.showItem(data.basketItems[0], data.basketItems.length - 1);
            });
        }
    },

    computed:
    {
        ...mapState({
            basketItems: state => state.basket.items,
            isBasketItemQuantityUpdate: state => state.basket.isBasketItemQuantityUpdate,
            crossitems: state => state.snaply.crossSellingOverlay,
            manyItems: state => state.snaply.manyBasketItems,
        }),
        current()
        {
          let varId = this.$store.getters.currentItemVariation.variation.id;
          let toReturn = [];
          let items = this.basketItems.slice().reverse();
          for(let i = 0; i < items.length; i++)
          {
            if(parseInt(items[i].variationId) === parseInt(varId))
            {
              toReturn.push(items[i])
            }
          }
          if(toReturn.length > 0)
          {
            let current = toReturn[0];
            if(current.variation.data.images.variation.length > 0)
            {
              current.image = current.variation.data.images.variation[0]
            }
            else
            {
              current.image = current.variation.data.images.all[0]
            }

            return current;
          }
          let reserve = { "quantity": 0.5 }
          return reserve
        },
        manyMoreItems()
        {
            let items = [];
            let counting = 0;
            if(this.manyItems.length > 4)
            {
              counting = 4
            }
            else
            {
              counting = this.manyItems.length
            }
            for(let i = 0; i < counting; i++)
            {
              items.push(this.manyItems[i])
            }
            return {"items":items,"count":this.manyItems.length }
        },
        items()
        {
            return this.$store.state.snaply.crossSellingOverlay;
        },
        isLastBasketEntrySet()
        {
            return !isNullOrUndefined(this.basketItem);
        },

        variation()
        {
            if (this.firstBasketItem)
            {
                return this.firstBasketItem.variation ? this.firstBasketItem.variation.data : null;
            }

            return null;
        },

        itemName()
        {
            if (this.isLastBasketEntrySet)
            {
                return this.$options.filters.itemName(this.variation);
            }

            return "";
        },

        imageUrl()
        {
            if (this.isLastBasketEntrySet)
            {
                const images = this.$options.filters.itemImages(this.variation.images, "urlPreview");

                return this.$options.filters.itemImage(images);
            }

            return "";
        },

        imageAlternativeText()
        {
            if (this.isLastBasketEntrySet)
            {
                const images = this.$options.filters.itemImages(this.variation.images, "urlPreview");

                return this.$options.filters.itemImageAlternativeText(images);
            }

            return "";
        },

        urls()
        {
            return {
                basket: App.urls.basket,
                checkout: App.urls.checkout
            }
        }
    },

    methods:
    {
        showItem(basketItem, countAdditionalBasketItems)
        {
            if(this.firstBasketItem == null)
            {
              this.firstBasketItem = JSON.parse(JSON.stringify(basketItem));
            }
            this.basketItem = basketItem;
            this.countAdditionalBasketItems = countAdditionalBasketItems;
            this.price = this.firstBasketItem.price;
            if(this.firstTime === false)
            {
              this.firstTime = true;
              ModalService
                  .findModal(document.getElementById("add-item-to-basket-overlay"))
                  .stopTimeout();
              ModalService
                  .findModal(document.getElementById("add-item-to-basket-overlay"))
                  .setTimeout(this.defaultTimeToClose * 1000)
                  .show();
            }
            else
            {
              ModalService
                  .findModal(document.getElementById("add-item-to-basket-overlay"))
                  .stopTimeout();
              ModalService
                  .findModal(document.getElementById("add-item-to-basket-overlay"))
                  .setTimeout(this.defaultTimeToClose * 1000)
                  .show();
            }
        }
    }
}
</script>
